export enum DrillsRoutes {
  ROOT = '',
  CREATE = 'create',
  DETAIL = 'detail',
  EDIT = 'edit'
}
